import React from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import { applyEnv, applyProcessEnv, loadRuntimeConfig } from './utils/config'
import './sass/site.scss'

applyProcessEnv()
applyEnv(import.meta.env)

async function boot() {
  await loadRuntimeConfig()
  const root = createRoot(document.getElementById(`root`))
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  )
}

boot()
